module.exports = __webpack_public_path__ + "images/dashboard-safe-32cfeb30ff799b5bc3e602a7fe6aaef7.png";